import { render, staticRenderFns } from "./AgregarContenidoModal.vue?vue&type=template&id=fad34128&scoped=true"
import script from "./AgregarContenidoModal.vue?vue&type=script&lang=js"
export * from "./AgregarContenidoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad34128",
  null
  
)

export default component.exports